import React,{useState,useEffect} from 'react';
import {ErrorBoundary} from 'react-error-boundary'
import BuildImageDiv from './build_image_div';
import AlbumsInfoSectionTemplate from './album_info_section_template';
import handleToken from './handle_token';
import SitePromo from './site_promo';
import { scrollPage } from './scroll_page';
import SingleAlbumGrid from './single_album_grid';
import GlobalConstants from '../../projects_module/constants';
import ErrorPortalComponent from '../../common/error_portal/ErrorPortalComponent';
import { saveImageModelForDetailView } from "../utility/utils";
import {handlePageNameOnLoad} from "./omniture";

const App = ({processedDataInitialValue = null}) => {  
        photoOrg.tracker =  new photoOrg.Tracker();
        if(!photoOrg.isPublicShareLandingOmnitureTrack){
            photoOrg.isPublicShareLandingOmnitureTrack = true;
            handlePageNameOnLoad();
        }
        let  uniqPubShareID=undefined;
        if(!photoOrg.oauthInfo.GSID){
            uniqPubShareID = 'LIB-' + photoOrg.Util.guid();
        }
        const [processedData,setProcessedData] = useState(processedDataInitialValue);
        const [globalError,setglobalError] = useState({noodle: "", errorId: "", show: false});
        const [showTitle, setshowTitle] = useState(false);
        useEffect(() => {         
            photoOrg.tracker.add(photoOrg.tracker.constants.PUBLIC_SHARE_LANDING_PAGE);
            photoOrg.history.current_state = photoOrg.history.navType.singleAlbum;
            
            handleToken(setProcessedData,uniqPubShareID);
            
        },[handleToken])
        
        let children = null;
        if(processedData && processedData.setImagesJson && processedData.setImagesJson.length>0){
            children = processedData.setImagesJson.map((model)=>{
                saveImageModelForDetailView(model);        
                return (<BuildImageDiv   key={model.assetId}coverImage={processedData.coverImage} caption={processedData.singleAlbumContext.caption} {...model} showTitle={showTitle} ></BuildImageDiv>)
            })
        }

        
        const errorHandler =({ detail }) => { 
          console.log(detail); 
          if(!globalError.show){                                                       
              setglobalError(Object.assign({}, globalError, detail));
          }
      }


      document.removeEventListener(GlobalConstants.ERROR_NOTIFY,errorHandler)
      document.addEventListener(GlobalConstants.ERROR_NOTIFY, errorHandler)


        const ErrorFallbackComponentForApp=({error, resetErrorBoundary})=>{
            return null;
        }
       
        const LogRenderingError=(error, info)=>{
            photoOrg.clientLogger.error({description: "LIBRARY:App:myErrorHandler:Exception", errorCode: "LIBRARY:PUBLIC_SHARE_LANDING_PAGE", err_desc: error.message, err_stack: error.stack});

        }
        const hideErrorOverlay = () =>{
          setglobalError(Object.assign({}, globalError,{show:false}))
        }
    
        return (<React.Fragment>
                {
                (processedData && processedData.singleAlbumContext)?(
                    <React.Fragment>                        
                        <ErrorBoundary FallbackComponent={ErrorFallbackComponentForApp} onError={LogRenderingError}>
                            <div className="sf-library">
                            <div id="library" className="photo-Org" style={{background: "rgb(255, 255, 255)", top: "50px"}}>
                                    <div id="mobile-overlay"></div>
                                    <div id="overlay"></div>
                                    <div role="dialog" id="detailedViewContainer" className="detailedViewContainer" aria-label="photo" aria-modal="true" style={{display:"none"}}></div>
                                    <div className="main-Container2 inner-wrap public-no-subheader" style={{marginRight:"0px"}}>
                                        <div id="right-well" className="small-12 medium-8 large-10 columns full">
                                            <div id="pfluidGrid" className="fluidGridContainer">
                                                <div id="album_assets" style={{margin:"-50px 0px 0px 0px"}}>
                                                        <div id="savAssetOperationsArea" className="sub-header-wrapper"> </div>
                                                        <div onScroll={(e)=>scrollPage(e)} data-testid ="on_scroll" className="scroll_sav_grid scoll-top-50 sav_11046226212070" style={{overflow: "auto"}}>
                                                            <AlbumsInfoSectionTemplate singleAlbumContext={processedData.singleAlbumContext} setshowTitle={setshowTitle} showTitle={showTitle}  /> 
                                                            <SingleAlbumGrid  childElements={children}/>                       
                                                        </div>   
                                                    {photoOrg.config.public_share_landing_promo_layer ?<SitePromo />: null}  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </ErrorBoundary>
                    </React.Fragment>  
                ): ""
            }
            <ErrorPortalComponent globalError={globalError} hideErrorOverlay={hideErrorOverlay}  translations = {photoOrg.translations.photos} />
            </React.Fragment>)
} 

export default App;